(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["horizontal-collection-scroll"] && !Shopify.designMode) return;
  try {
    


// Swiper desktop initializer for your collection-slider (desktop-only)
document.addEventListener('DOMContentLoaded', function () {
  const DESKTOP_BREAKPOINT = 1200;
  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';

  const horizontalSection = document.querySelector('.horizontal-section');
  if (!horizontalSection) return;

  const stickyWrapper = horizontalSection.querySelector('.sticky-wrapper');
  const elementWrapper = horizontalSection.querySelector('.element-wrapper');
  if (!stickyWrapper || !elementWrapper) return;

  let swiperInstance = null;
  let loadedSwiperAssets = false;

  // load CSS/JS if needed
  function ensureSwiperAssets() {
    return new Promise((resolve, reject) => {
      if (window.Swiper) { loadedSwiperAssets = true; return resolve(); }

      // load CSS
      if (!document.querySelector(`link[href="${SWIPER_CSS}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        document.head.appendChild(link);
      }

      // load JS
      if (document.querySelector(`script[src="${SWIPER_JS}"]`)) {
        // script already added but not yet available
        const check = setInterval(() => {
          if (window.Swiper) { clearInterval(check); loadedSwiperAssets = true; resolve(); }
        }, 50);
        // fallback timeout
        setTimeout(() => { if (!window.Swiper) reject(new Error('Swiper load timeout')); }, 8000);
        return;
      }

      const script = document.createElement('script');
      script.src = SWIPER_JS;
      script.async = true;
      script.onload = () => { loadedSwiperAssets = true; resolve(); };
      script.onerror = () => reject(new Error('Failed to load Swiper script'));
      document.body.appendChild(script);
    });
  }

  // Convert existing DOM to Swiper-friendly classes (no markup move)
  function markSlides() {
    // add swiper container class to sticky wrapper
    stickyWrapper.classList.add('swiper-container', 'collection-swiper');

    // convert elementWrapper to swiper-wrapper
    elementWrapper.classList.add('swiper-wrapper');

    // each direct child article becomes swiper-slide
    const slides = Array.from(elementWrapper.children);
    slides.forEach(slide => {
      slide.classList.add('swiper-slide');
      // ensure full height so image/content fits center
      slide.style.height = '100vh';
      slide.style.boxSizing = 'border-box';
    });
  }

  function unmarkSlides() {
    stickyWrapper.classList.remove('swiper-container', 'collection-swiper');
    elementWrapper.classList.remove('swiper-wrapper');
    const slides = Array.from(elementWrapper.children);
    slides.forEach(slide => {
      slide.classList.remove('swiper-slide');
      slide.style.height = '';
      slide.style.boxSizing = '';
    });
  }

  // Initialize Swiper with coverflow 3D + autoplay + loop
  function initSwiper() {
    if (!loadedSwiperAssets || !window.Swiper) return;
    if (swiperInstance) return;

    markSlides();

    // Ensure sticky wrapper behaves as container full-screen
    stickyWrapper.style.position = 'relative';
    stickyWrapper.style.height = '100vh';
    stickyWrapper.style.overflow = 'hidden';

    const config = {
      // container is stickyWrapper element
      // (we will instantiate by passing the element)
      modules: window.Swiper ? window.Swiper : [],
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      spaceBetween: 40,
      effect: 'coverflow', // nice 3D look
      coverflowEffect: {
        rotate: 18,
        stretch: 10,
        depth: 160,
        modifier: 1,
        slideShadows: false,
      },
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      grabCursor: true,
      watchSlidesProgress: true,
      // accessible pagination (dots)
      pagination: {
        el: stickyWrapper.querySelector('.collection-swiper-pagination') || createPaginationEl(),
        clickable: true,
      },
      // navigation (optional arrows) - not injected by default
      //navigation: { nextEl: ..., prevEl: ... },
      on: {
        init: function () {
          // add active class to center slide for your CSS animations
          requestAnimationFrame(() => {
            updateActiveBySwiper(this);
          });
        },
        slideChange: function () {
          updateActiveBySwiper(this);
        },
        resize: function () {
          // keep sticky wrapper height correct
          stickyWrapper.style.height = window.innerHeight + 'px';
        }
      },
      // responsive breakpoints to fine-tune coverflow on very large screens
      breakpoints: {
        1400: {
          spaceBetween: 60,
          coverflowEffect: { depth: 220, rotate: 18, stretch: 20 }
        },
        1900: {
          spaceBetween: 80,
          coverflowEffect: { depth: 260, rotate: 18, stretch: 30 }
        }
      }
    };

    // instantiate
    swiperInstance = new Swiper(stickyWrapper, config);

    // force update & layout fixes after images loaded
    setTimeout(() => {
      try { swiperInstance.update(); swiperInstance.slideTo(0, 0); } catch(e) {}
    }, 200);
  }

  function createPaginationEl() {
    const pag = document.createElement('div');
    pag.className = 'collection-swiper-pagination';
    // insert pagination at bottom of stickyWrapper (absolute)
    pag.style.position = 'absolute';
    pag.style.left = '50%';
    pag.style.transform = 'translateX(-50%)';
    pag.style.bottom = '18px';
    pag.style.zIndex = 9999;
    stickyWrapper.appendChild(pag);
    return pag;
  }

  // Sync 'active' class on your original slide elements (for CSS)
  function updateActiveBySwiper(swiper) {
    // swiper.slides are DOM nodes representing .swiper-slide
    const slides = Array.from(elementWrapper.children);
    slides.forEach(slide => slide.classList.remove('active'));
    // Swiper keeps classes - find the visible real index
    const activeSlide = elementWrapper.querySelector('.swiper-slide.swiper-slide-active');
    if (activeSlide) activeSlide.classList.add('active');
  }

  // Destroy swiper and restore DOM to original state
  function destroySwiper() {
    if (!swiperInstance) return;
    try {
      swiperInstance.destroy(true, true);
    } catch (e) { /* ignore */ }
    swiperInstance = null;
    // remove pagination if created
    const pag = stickyWrapper.querySelector('.collection-swiper-pagination');
    if (pag) pag.remove();
    // Unmark classes added
    unmarkSlides();
    // reset inline styles we used
    stickyWrapper.style.position = '';
    stickyWrapper.style.height = '';
    stickyWrapper.style.overflow = '';
  }

  // Re-init logic based on viewport
  function handleResponsive() {
    const w = window.innerWidth;
    if (w >= DESKTOP_BREAKPOINT) {
      ensureSwiperAssets()
        .then(initSwiper)
        .catch(err => { console.warn('Swiper failed to load:', err); });
    } else {
      // destroy for tablet/mobile so existing mobile slider stays
      destroySwiper();
    }
  }

  // Debounced resize handler
  let resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResponsive, 150);
  });

  // Ensure images are loaded before init (prevents height glitches)
  const imgs = elementWrapper.querySelectorAll('img');
  let loadedCount = 0;
  if (imgs.length === 0) {
    handleResponsive();
  } else {
    imgs.forEach(img => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === imgs.length) handleResponsive();
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === imgs.length) handleResponsive();
        }, { once: true });
      }
    });
    // safety fallback
    setTimeout(handleResponsive, 600);
  }

  // expose for debugging (optional)
  window.__collectionSliderSwiper = {
    get instance() { return swiperInstance; },
    destroy: destroySwiper,
    init: () => ensureSwiperAssets().then(initSwiper)
  };
});



/*

document.addEventListener('DOMContentLoaded', function () {

    const horizontalSection = document.querySelector('.horizontal-section');
    if (!horizontalSection) return;

    const stickyWrapper = horizontalSection.querySelector('.sticky-wrapper');
    const elementWrapper = horizontalSection.querySelector('.element-wrapper');
    const slides = Array.from(elementWrapper.querySelectorAll('.collection_list__items'));
    const desktopBreakpoint = 1200;

    
    function initialize() {

        const windowWidth = window.innerWidth;

        // total width needed for horizontal scrolling
        const totalWidth = elementWrapper.scrollWidth;
        const scrollWidth = Math.max(totalWidth - windowWidth, 0);

        // ⭐ Correct height: horizontal scroll distance + viewport
        const totalHeight = scrollWidth + window.innerHeight;

        horizontalSection.style.height = totalHeight + 'px';

        // ⭐ Re-apply sticky behavior manually
        stickyWrapper.style.position = 'sticky';
        stickyWrapper.style.top = '0px';
        stickyWrapper.style.height = window.innerHeight + 'px';
        stickyWrapper.style.overflow = 'hidden';

        // wrapper must match viewport height
        elementWrapper.style.height = window.innerHeight + 'px';

        onScroll();
    }


    
    function onScroll() {

        const windowWidth = window.innerWidth;

        // mobile/tablet falls back to static layout
        if (windowWidth < desktopBreakpoint) {
            elementWrapper.style.transform = 'translateX(0px)';
            slides.forEach(s => s.classList.remove('active'));
            return;
        }

        const sectionTop = horizontalSection.offsetTop;
        const scrollY = window.scrollY;

        // how far we have scrolled INTO the horizontal-section
        const rawScroll = scrollY - sectionTop;

        const totalWidth = elementWrapper.scrollWidth;
        const maxScroll = Math.max(totalWidth - windowWidth, 0);

        // clamp within valid range
        const scrollX = Math.min(Math.max(rawScroll, 0), maxScroll);

        // ⭐ Smooth 3D-feel easing
        const eased = scrollX * 0.94;

        elementWrapper.style.transform = `translateX(-${eased}px)`;

        updateActiveSlide(eased, windowWidth);
    }


    
    function updateActiveSlide(scrollX, windowWidth) {

        const viewportCenter = scrollX + windowWidth / 2;

        let activeIndex = 0;
        let minDiff = Infinity;

        slides.forEach((slide, index) => {
            const center = slide.offsetLeft + slide.offsetWidth / 2;
            const diff = Math.abs(center - viewportCenter);

            if (diff < minDiff) {
                minDiff = diff;
                activeIndex = index;
            }
        });

        slides.forEach((slide, i) =>
            slide.classList.toggle('active', i === activeIndex)
        );
    }


    
    let ticking = false;
    function optimizedScroll() {
        if (!ticking) {
            requestAnimationFrame(() => {
                onScroll();
                ticking = false;
            });
            ticking = true;
        }
    }


    
    let startX = 0, isTouching = false;

    elementWrapper.addEventListener('touchstart', (e) => {
        if (window.innerWidth >= desktopBreakpoint) return;
        startX = e.touches[0].clientX;
        isTouching = true;
    }, { passive: true });

    elementWrapper.addEventListener('touchmove', (e) => {
        if (!isTouching) return;
        const currentX = e.touches[0].clientX;
        const delta = startX - currentX;
        elementWrapper.scrollLeft += delta;
        startX = currentX;
    }, { passive: true });

    elementWrapper.addEventListener('touchend', () => {
        isTouching = false;
    });


    
    const imgs = elementWrapper.querySelectorAll('img');
    let loaded = 0;

    function tryInit() {
        if (loaded === imgs.length) initialize();
    }

    if (imgs.length === 0) {
        initialize();
    } else {
        imgs.forEach(img => {
            if (img.complete) {
                loaded++;
                tryInit();
            } else {
                img.addEventListener('load', () => {
                    loaded++;
                    tryInit();
                }, { once: true });
            }
        });
    }

    // fallback init
    setTimeout(initialize, 250);

    window.addEventListener('scroll', optimizedScroll, { passive: true });
    window.addEventListener('resize', () => setTimeout(initialize, 150));

});

*/



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-v5-23-12-25"] && !Shopify.designMode) return;
  try {
    

(function loadSwiperScriptOnce(){
  if (window.Swiper) return;
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
  s.defer = true;
  document.head.appendChild(s);
})();

document.addEventListener("DOMContentLoaded", function () {

  function waitForSwiper(cb) {
    if (window.Swiper) return cb();
    setTimeout(() => waitForSwiper(cb), 80);
  }

  waitForSwiper(function () {

    const container = document.querySelector('.mobile-swiper-container');
    if (!container) return;

    let swiperInstance = null;
    let initialized = false;

    function mountSwiper() {

      if (window.innerWidth > 1024) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
          initialized = false;
        }
        return;
      }

      if (initialized) return;

      swiperInstance = new Swiper('.mobile-swiper-container', {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        loop: true,
        speed: 900,
        grabCursor: true,
        parallax: true,

        //autoplay: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        on: {
          init() {
            initialized = true;
          },
          slideChangeTransitionStart() {
            const slides = this.slides;
            slides.forEach(slide => {
              const img = slide.querySelector('.hero-bg-image');
              if (img) {
                img.style.transitionDuration = '0s';
                img.style.transform = 'scale(1)';
              }
            });
          },
          slideChangeTransitionEnd() {
            const activeSlide = this.slides[this.activeIndex];
            const img = activeSlide.querySelector('.hero-bg-image');
            if (img) {
              img.style.transitionDuration = '6.5s';
              img.style.transform = 'scale(1.08)';
            }
          }
        }


        // on: {
        //   init() {
        //     initialized = true;
        //   }
        // }
      });
    }

    mountSwiper();

    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(mountSwiper, 150);
    }, { passive: true });

    window.addEventListener('orientationchange', () => {
      setTimeout(mountSwiper, 200);
    });
  });
});


/*

(function loadSwiperScriptOnce(){
      if (window.Swiper) return;
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
      s.defer = true;
      document.head.appendChild(s);
    })();

// Mobile Swiper Coverflow initialization (robust)
document.addEventListener("DOMContentLoaded", function () {

  const initWhenReady = function(callback) {
    // Wait for Swiper library to load
    const waitForSwiper = function(cb) {
      if (window.Swiper) return cb();
      // check every 80ms
      setTimeout(function(){ waitForSwiper(cb); }, 80);
    };
    waitForSwiper(callback);
  };

  initWhenReady(function(){
    const containerSelector = '.mobile-swiper-container';
    const container = document.querySelector(containerSelector);
    if (!container) return;

    let swiperInstance = null;
    let initialized = false;

    function ensureImagesLoaded(sliderEl) {
      const imgs = sliderEl.querySelectorAll('img');
      if (imgs.length === 0) return Promise.resolve();
      let loaded = 0;
      return new Promise((resolve) => {
        imgs.forEach(img => {
          if (img.complete) {
            loaded++;
            if (loaded === imgs.length) resolve();
          } else {
            img.addEventListener('load', function onLoad(){
              loaded++;
              img.removeEventListener('load', onLoad);
              if (loaded === imgs.length) resolve();
            });
            img.addEventListener('error', function onErr(){
              loaded++;
              img.removeEventListener('error', onErr);
              if (loaded === imgs.length) resolve();
            });
          }
        });
      });
    }

    function mountSwiper() {
      const winW = window.innerWidth || document.documentElement.clientWidth;
      if (winW > 1024) {
        // destroy if exists
        if (swiperInstance) {
          try { swiperInstance.destroy(true, true); } catch(e){}
          swiperInstance = null;
          initialized = false;
        }
        return;
      }

      // initialize only once
      if (initialized) return;

      ensureImagesLoaded(container).then(() => {
        // create Swiper
        swiperInstance = new Swiper(containerSelector, {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: true,
          speed: 700,
          // autoplay: {
          //   delay: 3200,
          //   disableOnInteraction: false,
          // },
          coverflowEffect: {
            rotate: 12,
            stretch: 0,
            depth: 140,
            modifier: 1,
            slideShadows: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            init: function() {
              initialized = true;
              // small reflow
              try { this.update(); this.slideToLoop(0, 0); } catch(e){}
            },
            slideChangeTransitionEnd: function() {
              // ensure reflow after each change
              try { this.update(); } catch(e){}
            },
            beforeResize: function(){},
            resize: function(){
              // if screen changed to desktop, destroy
              if ((window.innerWidth || document.documentElement.clientWidth) > 1024) {
                try { this.destroy(true, true); } catch(e){}
                initialized = false;
                swiperInstance = null;
              }
            }
          }
        });

        // ensure no horizontal page scroll from 3D transforms
        document.documentElement.style.overflowX = 'hidden';
        document.body.style.overflowX = 'hidden';
      });
    }

    // Load initial
    mountSwiper();

    // Re-check on resize + orientationchange (debounced)
    let t;
    window.addEventListener('resize', function(){
      clearTimeout(t);
      t = setTimeout(mountSwiper, 150);
    }, {passive:true});

    window.addEventListener('orientationchange', function(){
      setTimeout(mountSwiper, 200);
    });

    // Extra safety: if Swiper loads after DOM ready, attempt mount again
    setTimeout(mountSwiper, 600);
  });
});

*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-v5"] && !Shopify.designMode) return;
  try {
    

(function loadSwiperScriptOnce(){
  if (window.Swiper) return;
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
  s.defer = true;
  document.head.appendChild(s);
})();

document.addEventListener("DOMContentLoaded", function () {

  function waitForSwiper(cb) {
    if (window.Swiper) return cb();
    setTimeout(() => waitForSwiper(cb), 80);
  }

  waitForSwiper(function () {

    const container = document.querySelector('.mobile-swiper-container');
    if (!container) return;

    let swiperInstance = null;
    let initialized = false;

    function mountSwiper() {

      if (window.innerWidth > 1024) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
          initialized = false;
        }
        return;
      }

      if (initialized) return;

      swiperInstance = new Swiper('.mobile-swiper-container', {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        loop: true,
        speed: 900,
        grabCursor: true,
        parallax: true,

        //autoplay: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        on: {
          init() {
            initialized = true;
          },
          slideChangeTransitionStart() {
            const slides = this.slides;
            slides.forEach(slide => {
              const img = slide.querySelector('.hero-bg-image');
              if (img) {
                img.style.transitionDuration = '0s';
                img.style.transform = 'scale(1)';
              }
            });
          },
          slideChangeTransitionEnd() {
            const activeSlide = this.slides[this.activeIndex];
            const img = activeSlide.querySelector('.hero-bg-image');
            if (img) {
              img.style.transitionDuration = '6.5s';
              img.style.transform = 'scale(1.08)';
            }
          }
        }


        // on: {
        //   init() {
        //     initialized = true;
        //   }
        // }
      });
    }

    mountSwiper();

    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(mountSwiper, 150);
    }, { passive: true });

    window.addEventListener('orientationchange', () => {
      setTimeout(mountSwiper, 200);
    });
  });
});


/*

(function loadSwiperScriptOnce(){
      if (window.Swiper) return;
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
      s.defer = true;
      document.head.appendChild(s);
    })();

// Mobile Swiper Coverflow initialization (robust)
document.addEventListener("DOMContentLoaded", function () {

  const initWhenReady = function(callback) {
    // Wait for Swiper library to load
    const waitForSwiper = function(cb) {
      if (window.Swiper) return cb();
      // check every 80ms
      setTimeout(function(){ waitForSwiper(cb); }, 80);
    };
    waitForSwiper(callback);
  };

  initWhenReady(function(){
    const containerSelector = '.mobile-swiper-container';
    const container = document.querySelector(containerSelector);
    if (!container) return;

    let swiperInstance = null;
    let initialized = false;

    function ensureImagesLoaded(sliderEl) {
      const imgs = sliderEl.querySelectorAll('img');
      if (imgs.length === 0) return Promise.resolve();
      let loaded = 0;
      return new Promise((resolve) => {
        imgs.forEach(img => {
          if (img.complete) {
            loaded++;
            if (loaded === imgs.length) resolve();
          } else {
            img.addEventListener('load', function onLoad(){
              loaded++;
              img.removeEventListener('load', onLoad);
              if (loaded === imgs.length) resolve();
            });
            img.addEventListener('error', function onErr(){
              loaded++;
              img.removeEventListener('error', onErr);
              if (loaded === imgs.length) resolve();
            });
          }
        });
      });
    }

    function mountSwiper() {
      const winW = window.innerWidth || document.documentElement.clientWidth;
      if (winW > 1024) {
        // destroy if exists
        if (swiperInstance) {
          try { swiperInstance.destroy(true, true); } catch(e){}
          swiperInstance = null;
          initialized = false;
        }
        return;
      }

      // initialize only once
      if (initialized) return;

      ensureImagesLoaded(container).then(() => {
        // create Swiper
        swiperInstance = new Swiper(containerSelector, {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: true,
          speed: 700,
          // autoplay: {
          //   delay: 3200,
          //   disableOnInteraction: false,
          // },
          coverflowEffect: {
            rotate: 12,
            stretch: 0,
            depth: 140,
            modifier: 1,
            slideShadows: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            init: function() {
              initialized = true;
              // small reflow
              try { this.update(); this.slideToLoop(0, 0); } catch(e){}
            },
            slideChangeTransitionEnd: function() {
              // ensure reflow after each change
              try { this.update(); } catch(e){}
            },
            beforeResize: function(){},
            resize: function(){
              // if screen changed to desktop, destroy
              if ((window.innerWidth || document.documentElement.clientWidth) > 1024) {
                try { this.destroy(true, true); } catch(e){}
                initialized = false;
                swiperInstance = null;
              }
            }
          }
        });

        // ensure no horizontal page scroll from 3D transforms
        document.documentElement.style.overflowX = 'hidden';
        document.body.style.overflowX = 'hidden';
      });
    }

    // Load initial
    mountSwiper();

    // Re-check on resize + orientationchange (debounced)
    let t;
    window.addEventListener('resize', function(){
      clearTimeout(t);
      t = setTimeout(mountSwiper, 150);
    }, {passive:true});

    window.addEventListener('orientationchange', function(){
      setTimeout(mountSwiper, 200);
    });

    // Extra safety: if Swiper loads after DOM ready, attempt mount again
    setTimeout(mountSwiper, 600);
  });
});

*/

  } catch(e) { console.error(e); }
})();
})();
